export default __webpack_public_path__ + "static/media/ubuntu-icon.e40441e5.svg";